import { useState } from "react";
import { Collapse } from "react-bootstrap";
import { truncateString } from "utils/UtilityFuncs";
import useInbox from "../InboxContext";
import "./labelsList.scss";

export default function LabelDropdown({
  name,
  node,
  selectedLabel,
  setSelectedLabel,
  level = 0,
}) {
  /*   All States
   ********************************************* */
  const { setMessageId } = useInbox();

  const [expanded, setExpanded] = useState(false);
  const [hovered, setHovered] = useState(false);

  const hasChildren = Object.keys(node.__children).length > 0;
  const label = node.__label;

  /*   All Functions
   ********************************************* */

  /*   All UseEffects
   ********************************************* */

  return (
    <>
      <li>
        <div
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            setExpanded(!expanded);
            if (!hasChildren) {
              setMessageId(null);
              setSelectedLabel(label && label?.labelId);
            } else {
              // set first child label if parent is clicked
              let firstChildKey = Object.keys(node.__children)[0];
              let firstChildNode = node.__children[firstChildKey];
              let firstChildLabel = firstChildNode.__label
                ? firstChildNode.__label.labelId
                : null;
              setMessageId(null);
              setSelectedLabel(firstChildLabel);
            }
          }}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          className={`${
            selectedLabel === label?.labelId
              ? "d-flex align-items-center fw-bold px-3 py-1 active-inbox-item label-item"
              : "d-flex align-items-center fw-bold px-3 py-1 label-item"
          } ${hovered ? "label-item--hovered" : ""}`}
          aria-controls={`collapse-${label?.labelId}`}
          aria-expanded={expanded}
        >
          <div className="label-item__content">
            <span>
              <i
                className="mdi mdi-circle fs-6"
                style={{
                  color: label?.backgroundColor,
                }}
              ></i>
            </span>
            <span className="flex-grow-1 text-truncate d-flex align-items-center">
              {label?.name
                ? truncateString(label.name, 18)
                : truncateString(name, 18)}
              {label?.unreadCount > 0 && (
                <span className="badge bg-danger ms-2">
                  {label?.unreadCount}
                </span>
              )}
            </span>
            {hasChildren && (
              <>
                {expanded ? (
                  <i className="mdi mdi-chevron-down"></i>
                ) : (
                  <i className="mdi mdi-chevron-right"></i>
                )}
              </>
            )}
          </div>
          {/* {label?.labelId && !BUILTIN_LABEL_IDS.has(label.labelId) && (
            <button
              type="button"
              className={`label-item__delete ${deleting ? "is-loading" : ""}`}
              onClick={async (event) => {
                event.stopPropagation();
                console.log("deleting Started:");

                if (deleting) return;
                setDeleting(true);
                console.log("api call sent");
                const success = await deleteLabel(label.labelId);
                console.log("api call sent completed");
                if (!success) {
                  setDeleting(false);
                }
              }}
              title="Delete label"
            >
              <i
                className={`mdi ${
                  deleting ? "mdi-loading mdi-spin" : "mdi-delete"
                } fs-5`}
              ></i>
            </button>
          )} */}
        </div>
      </li>

      {hasChildren && (
        <Collapse in={expanded}>
          <div id={`collapse-${label?.labelId}`} className="ps-2 py-1 bg-light">
            {Object.entries(node?.__children).map(([childName, childNode]) => (
              <LabelDropdown
                key={childName}
                name={childName}
                node={childNode}
                selectedLabel={selectedLabel}
                setSelectedLabel={setSelectedLabel}
                level={level + 1}
              />
            ))}
          </div>
        </Collapse>
      )}
    </>
  );
}
